var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ui-game"},[_c('GameScore'),_c('footer',{staticClass:"ui-game__footer"},[_c('GamePowerupPercentage'),_c('GameLife')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }